import { render, staticRenderFns } from "./IframePageRenderer.vue?vue&type=template&id=c36a7a30&"
import script from "./IframePageRenderer.vue?vue&type=script&lang=ts&"
export * from "./IframePageRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports